import React, { Component } from 'react';
import { connect } from 'react-redux';
import { placeEbookOrder } from '../modules/order_actions';

import CustomBraintreeDropin  from './CustomBraintreeDropin.jsx';

import {priceOneItemCart}            from '../shared/cart.js';


class EbookPurchase extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isConfirmOpen: false
    };
    this.toggleConfirmState = this.toggleConfirmState.bind(this);
    this.additionalParams = { mmid: this.props.product.ebook.mmid };

    try {
      let bookPrice = this.props.product.ebook.price;
      let bookTaxGroup = this.props.product.ebook.tax_group;
      let priceObj = priceOneItemCart(bookPrice, 0, this.props.customer, false, bookTaxGroup);

      this.nEbookPrice = '$' + (bookPrice || 10).toFixed(2);
      this.ebookTax = '$' + (priceObj.tax).toFixed(2);
    }  catch(e){
      console.error("problems generating book price, tax and shipping");
      console.error(e);
    }
  }

  toggleConfirmState() {
    this.setState({isConfirmOpen: !this.state.isConfirmOpen});
  }

  render() {
    let oShowEbookPurchase = '';
    let bAlreadyPurchased = false;
    let aPurchasedEbooks = this.props.customer.ebooks;

    // Check if ebook has already been purchased
    aPurchasedEbooks.forEach((oEbook)=>{
      if(this.props.product.ebook.mmid === oEbook.mmid ){
         bAlreadyPurchased = true;
       }
    });

    switch(this.props.ebookOrderSuccess){
      case 'success' :
        oShowEbookPurchase = (
          <div>
            <div className="download">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="57px" height="41.188px" viewBox="455 328.188 57 41.188" enable-background="new 455 328.188 57 41.188">
              <g>
                <path d="M501.699,348.188c3.299-7.574,1.265-12.391-0.393-14.711c-2.515-3.521-7.094-5.452-11.115-4.679
                  c-6.992,1.334-9.973,6.073-9.973,15.858v8.171l-4.089-4.089c-0.688-0.688-1.808-0.688-2.497,0c-0.688,0.688-0.688,1.809,0,2.497
                  l7.105,7.103c0.356,0.356,0.826,0.519,1.292,0.508c0.467,0.011,0.937-0.151,1.292-0.508l7.14-7.138
                  c0.688-0.688,0.688-1.809,0-2.497c-0.688-0.688-1.809-0.688-2.494,0l-4.218,4.213v-8.26c0-10.184,3.507-11.702,7.097-12.391
                  c2.308-0.424,5.644,0.543,7.584,3.263c2.372,3.315,1.917,8.235-1.283,13.842c-0.338,0.597-0.304,1.335,0.093,1.894
                  c0.394,0.559,1.09,0.84,1.751,0.721c0.427-0.076,1.701-0.269,2.506-0.269c3.848,0,6.972,3.167,6.972,7.066
                  c0,3.895-3.168,7.062-7.062,7.062l-35.055,0.021c-4.104-0.606-7.32-4.495-7.32-8.85c0-4.337,3.256-8.068,7.578-8.687l1.519-0.219
                  c0.869-0.125,1.515-0.869,1.515-1.749l-0.028-1.878c0.011-6.325,3.909-11.522,9.28-12.359c0.961-0.152,1.621-1.052,1.473-2.017
                  c-0.152-0.964-1.031-1.617-2.021-1.473c-7.098,1.105-12.253,7.77-12.264,15.841c0,0.004,0.028,0.357,0.028,0.357l0,0
                  c-6.049,0.865-10.611,6.104-10.611,12.183c0,6.167,4.442,11.471,10.594,12.36h35.312c5.842,0,10.594-4.752,10.594-10.594
                  C512,353.006,507.396,348.295,501.699,348.188z"/>
              </g>
              </svg>
            </div>
            <h4 className="alt2">eBook Purchased</h4>
            <p>Your eBook is now available on the Readwell app.</p>
          </div>
        );
        break;

      case 'error' :
        oShowEbookPurchase = (
          <div>
            <h4 className="alt2">Ooops!</h4>
            <p>There was an issue processing your order.</p>
          </div>
        );
        break;

      default :
        if (bAlreadyPurchased){
          oShowEbookPurchase = (
            <div>
              <h5>eBook Purchased</h5>
              <p>Your eBook is available on the Readwell app.</p>
            </div>
          );
        }else{
          if( this.state.isConfirmOpen ){
            oShowEbookPurchase = (
              <div>
                <h6>Buy eBook for {this.nEbookPrice}</h6>
                <h7>+ {this.ebookTax} tax</h7>
                <CustomBraintreeDropin
                  submitFunction = {placeEbookOrder}
                  additionalParams = {this.additionalParams}
                  uniqueContainer = "ebook-form" />
                <span className="help-link" onClick={this.toggleConfirmState}>cancel</span>
              </div>
            );
          } else oShowEbookPurchase = '';
        }
    }

    return (
      <div>
        <button
          className={"btn-secondary" + (this.state.isConfirmOpen ? " hidden" : "")}
          name="buy-ebook"
          onClick={this.toggleConfirmState}
        >
          Buy eBook for {this.nEbookPrice}
        </button>
        <div className={"message-box" + (this.state.isConfirmOpen ? " showing" : "")} >
          <div className="loader" ></div>
         {oShowEbookPurchase}
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'ebookOrderSuccess': state.ebookOrderSuccess
    };
}

export default connect(mapStateToProps)(EbookPurchase);


// WEBPACK FOOTER //
// ./src/components/EbookPurchase.jsx